import styled from 'styled-components';
import { DeleteOutline } from '@material-ui/icons';
import { AddIcon } from '../../SVGs/Icons';
import { ValidityIndicator } from '../../forms';
import BaseStep from '../Step';
import BaseStage from './Stage';

export const Step = styled(BaseStep)`
  width: fit-content;
`;

export const AddButton = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  color: ${({ isHighlighted }) => (isHighlighted ? '#007ade' : '#616161')};
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  background-color: #ffffff;
  border: 1px solid #d1d1d1;
  border-radius: 13px;
  cursor: pointer;
  transition: background-color ease-in 250ms;
  width: 100%;

  &:hover {
    background-color: #0000000d;
  }
`;

AddButton.Icon = styled(AddIcon)``;

AddButton.Label = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  color: #004bc4;
`;

AddButton.Label.HelperText = styled.span`
  color: #9b9b9b;
  font-weight: 400;
  font-family: inherit;
`;

AddButton.ValidityIndicator = styled(ValidityIndicator)`
  margin-left: auto;
`;

export const StagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: fit-content;
`;

export const StageList = styled.ul`
  margin-bottom: 0;
  padding-left: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

StageList.Item = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  gap: 18px;
  transition: border-color 200ms;
  /* Extend hit area into the list gap so dragover/drop work when cursor is between stages */
  margin-top: -15px;
  padding-top: 15px;
  margin-bottom: -15px;
  padding-bottom: 15px;
  ${({ dragOverPosition, isDragging }) =>
    dragOverPosition &&
    !isDragging &&
    `
    &::before {
      content: '';
      position: absolute;
      left: -40px;
      right: 0;
      height: 2px;
      background-color: #007ade;
      border-radius: 1px;
      z-index: 1;
      ${dragOverPosition === 'above' ? 'top: -11px;' : 'bottom: -11px;'}
    }
  `}
  ${({ isDragging }) =>
    isDragging &&
    `
    opacity: 0.5;
  `}

  &:first-child {
    margin-top: 0;
    padding-top: 0;
  }
`;

export const Stage = styled(BaseStage)`
  width: 100%;
`;

export const DeleteButton = styled(DeleteOutline)`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(calc(100% + 16px), -50%);
  color: #888888;
  font-size: 24px !important;
  cursor: pointer;
  transition: color ease-in 250ms !important;

  &:hover {
    color: #ff6161;
    transition: color ease-out 250ms !important;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
